import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthRedirectService } from '../services/auth-redirect.service';
import { ElxKeycloakService } from '../services/keycloak.service';
import { PermissionService } from '../services/permission.service';

export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
) => {
  const router = inject(Router);
  const authTokenService = inject(ElxKeycloakService);
  const authRedirectService = inject(AuthRedirectService);
  const permissionService = inject(PermissionService);

  // Wait for Keycloak initialization to complete
  // This prevents the guard from running before tokens are restored
  if (typeof window !== 'undefined') {
    let attempts = 0;
    // Keycloak init + silent check-sso can exceed 5s on slower networks (e.g. app-test).
    const maxAttempts = 200; // 20 seconds max wait
    while (!(window as any).__keycloakInitCompleted && attempts < maxAttempts) {
      await new Promise((resolve) => setTimeout(resolve, 100));
      attempts++;
    }

    if (attempts >= maxAttempts) {
      permissionService.clearUserSessionCache();
      router.navigate(['/login']);
      return false;
    }
  }

  try {
    const isAuthenticated = await authTokenService.isLoggedIn();

    if (!isAuthenticated) {
      const currentUrl = window.location.pathname + window.location.search;
      if (!currentUrl.includes('/error/') && !currentUrl.includes('/login')) {
        authRedirectService.storeRedirectUrl(currentUrl);
      }

      permissionService.clearUserSessionCache();
      await router.navigate(['/login']);
      return false;
    }

    return true;
  } catch (error) {
    permissionService.clearUserSessionCache();
    await router.navigate(['/login']);
    return false;
  }
};
